/**
 * This file is auto-generated from CtaSection.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const ctaHeading: Translation = lang => {
    switch (lang) {
        case 'en':
            return "Your health shouldn't wait.";
        case 'pl':
            return 'Potrzebujesz porady lekarskiej, recepty lub zwolnienia?';
    }
};

export const ctaDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Fill out a simple, automated survey of your symptoms. Then recieve your treatment plan from a physician.';
        case 'pl':
            return 'Opisz objawy, a lekarz opracuje plan leczenia. Bez czekania.';
    }
};

export const iphoneShowingHealed: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'iPhone showing Healed application';
        case 'pl':
            return 'iPhone pokazujący aplikację Healed';
    }
};
